const os = {
    homedir: () => '/'
};
export default os;
